import { useEffect, useState } from "react";
import Footer from "../components/global/Footer";
import Header from "../components/global/Header";
import HashLoader from "react-spinners/HashLoader";

const Main = props => {
	const [loading, setLoading] = useState(false)

	useEffect(() => {

		setLoading(true)
		setTimeout(() => {
			setLoading(false)
		}, 700)
	}, [])
	return (
		<>
			{loading ? (
				<div className="flex items-center flex-col justify-center h-[100vh] w-full bg-[#181818]">

					<HashLoader

						color={'#ffffff'}
						loading={loading}
						size={40}
						aria-label="Loading Spinner"
						data-testid="loader"
					/>
					<h6 className="absolute z-10 text-sm text-white uppercase bottom-1 left-2">Loading Gulfam Haider's Portfolio...</h6>
				</div>
			) : (
				<>
					<Header />
					<div className="">

						{props.children}
					</div>
					<Footer />
				</>
			)}
		</>
	);
};

export default Main;
